export default {
  title: 'Payer avec PayPal',
  error: "Le paiement PayPal n'a pas pu être effectué. Veuillez réessayer.",
};
